import { Component, ChangeDetectionStrategy, input } from '@angular/core';

export type TagSeverity = 'success' | 'warn' | 'danger' | 'info' | 'neutral' | 'accent';

/**
 * Pastille de statut (priorités, catégories, badges Éros…).
 *
 * Usage : <idra-tag value="haute" severity="danger" />
 *         <idra-tag severity="accent">Éros</idra-tag>
 */
@Component({
  selector: 'idra-tag',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.success]': "severity() === 'success'",
    '[class.warn]': "severity() === 'warn'",
    '[class.danger]': "severity() === 'danger'",
    '[class.info]': "severity() === 'info'",
    '[class.neutral]': "severity() === 'neutral'",
    '[class.accent]': "severity() === 'accent'",
  },
  styles: `
    :host {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 2px 10px;
      border-radius: var(--idra-radius-full);
      font-size: 12px;
      font-weight: 700;
    }

    :host(.success) {
      background: var(--idra-success-bg);
      color: var(--idra-primary-soft-text);
    }
    :host(.warn) {
      background: var(--idra-warning-bg);
      color: var(--idra-warning);
    }
    :host(.danger) {
      background: var(--idra-danger-bg);
      color: var(--idra-danger);
    }
    :host(.info) {
      background: var(--idra-info-bg);
      color: var(--idra-info);
    }
    :host(.neutral) {
      background: var(--idra-surface-200);
      color: var(--idra-text-secondary);
    }
    :host(.accent) {
      background: var(--idra-accent-soft);
      color: var(--idra-accent);
    }
  `,
  template: `
    {{ value() }}
    <ng-content />
  `,
})
export class IdraTag {
  readonly value = input<string | undefined>(undefined);
  readonly severity = input<TagSeverity>('neutral');
}
